import React from 'react';
import { Component } from "react";
import { API_URL } from '../urls';
import {Button} from "react-bootstrap";
import {Alert} from "react-bootstrap";
import DefaultLayout from "../layouts/Default";
require('odatajs');

class ProductsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      pending: true,
      data: null,
      showError : false
    };
  }

  componentDidMount() {
    document.title = "Products list";

    let token = localStorage.getItem('_TOKEN_AUTH');
    var headers = { 'Content-Type': 'application/json', Accept: 'application/json', Authorization: "Bearer " + token };
    var request = {
        requestUri: API_URL + "Products",
        method: 'GET',
        headers: headers
    };
    window.odatajs.oData.request(
        request,
        (data, response) => {
          	this.setState({
	            pending: false,
        	    data: data.value
	        });
            },
            (error) => {
                if(error.response.statusCode === 401){
                  window.location.href = "/login";
                }
                this.setState({pending: false, error: error.message, showError:true});
            }
        );
    }
    render() { 
	const { pending, data } = this.state;
	if (pending) {
		return <div>Loading...</div>;
	} else {
	        return (
<DefaultLayout>
<Alert variant="danger" onClose={() => this.setState({showError : false})} show={this.state.showError} dismissible>
          <Alert.Heading>{this.state.error}</Alert.Heading>
          <p>Failed to load product list. Please check your internet connection and try again.</p>
        </Alert>

<h1 >Products</h1>
<ul>
{!data || data.map((data, index) => ( <li><a href={"/product/" + data.Name}>{data.Name}</a></li> ))}
</ul>
<Button href={"/products/create"}>Create product</Button>

</DefaultLayout>
		);
	}
    }
}
 
export default ProductsPage;